import { ComponentPropsWithoutRef, FC } from 'react';
import { ProfileHeightLgIcon } from './ProfileHeightLgIcon';
import { ProfileHeightMdIcon } from './ProfileHeightMdIcon';
import { ProfileHeightSmIcon } from './ProfileHeightSmIcon';
import { ProfileHeightXlIcon } from './ProfileHeightXlIcon';
import { ProfileHeightXsIcon } from './ProfileHeightXsIcon';
import { ProfileHeightXxlIcon } from './ProfileHeightXxlIcon';

export interface ProfileHeightIconProps extends ComponentPropsWithoutRef<'svg'> {
  height: number;
}

export const ProfileHeightIcon: FC<ProfileHeightIconProps> = ({ height, ...svgProps }) => {
  if (height <= 123) {
    return <ProfileHeightXsIcon {...svgProps} />;
  }

  if (height <= 139) {
    return <ProfileHeightSmIcon {...svgProps} />;
  }

  if (height <= 153) {
    return <ProfileHeightMdIcon {...svgProps} />;
  }

  if (height <= 169) {
    return <ProfileHeightLgIcon {...svgProps} />;
  }

  if (height < 183) {
    return <ProfileHeightXlIcon {...svgProps} />;
  }

  return <ProfileHeightXxlIcon {...svgProps} />;
};
